<template>
	<div class="usuarios-container">
		<user-table
			:data="myData"
			:loadingtable="isloading"
			@editaction="editperson($event)"
			@searchtext="handleSearch($event)"
			@changeoptiontable="changeOption($event)"
			@page-change="pagechange($event)"
			@update-table="lastupdatefilter === 2 ? getUsers() : changeOption(lastupdatefilter)"
		/>
	</div>
</template>

<script>
import * as ecAxios from '@/util/ecAxios';
import userTable from '../../layout/components/table/admuser';

export default {
	components: {
		userTable,
	},
	data() {
		return {
			lastupdatefilter: 2,
			dados: [],
			searchTerm: '',
			isloading: true,
			datacarduser: {
				qt: 1131,
				percent: '5%',
				icon: {
					size: '18px',
					type: 'trending-up',
					bgColor: 'rgba(0,201,167,.1)',
					color: '#00c9a7',
				},
			},
			datacardactive: {
				qt: 1131,
				percent: '5%',
				icon: {
					size: '18px',
					type: 'trending-up',
					bgColor: 'rgba(0,201,167,.1)',
					color: '#00c9a7',
				},
			},

			datacarddisabled: {
				qt: 1131,
				percent: '-5%',
				icon: {
					size: '18px',
					type: 'trending-down',
					bgColor: 'rgba(237,76,120,.1)',
					color: '#ed4c78',
				},
			},

			datacardnew: {
				qt: 1131,
				percent: '-5%',
				icon: {
					size: '18px',
					type: 'trending-down',
					bgColor: 'rgba(237,76,120,.1)',
					color: '#ed4c78',
				},
			},
		};
	},
	computed: {
		myData() {
			const search = this.searchTerm;
			if (search) {
				return this.dados.filter(
					(item) => this.filterSearch(item.usuario) || this.filterSearch(item.id)
				);
			}
			return this.dados;
		},
	},
	activated() {
		if (!this.dados || !this.dados.length || this.$store.getters.getUpdateAdmUserTable) {
			this.getUsers();
			this.$store.dispatch('setUpdateAdmUserTable', false);
		}
	},
	methods: {
		goBack() {
			this.$router.push('/');
		},
		handleSearch(searchTerm) {
			this.searchTerm = searchTerm;
		},
		filterSearch(field) {
			if (typeof field === 'number') {
				// eslint-disable-next-line no-param-reassign
				field = field.toString();
			}
			if (field === null) {
				// eslint-disable-next-line no-param-reassign
				field = '';
			}
			return field.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
		},
		async changeOption(evt) {
			this.lastupdatefilter = evt;
			if (evt === '2') {
				this.getUsers();
			} else {
				this.isloading = true;
				await ecAxios
					.connection()
					.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIOS}`, {
						offset: 0,
						limit: 9999999999,
						searchTerm: '',
						status: evt,
					})
					.then((response) => {
						if (response) {
							this.dados = response.data.usuarios;
							this.datacarduser.qt = this.dados.length;
							this.isloading = false;
						}
					})
					.catch((e) => {
						this.isloading = false;
						this.$buefy.notification.open({
							message: e,
							type: 'is-danger',
						});
					});
			}
		},
		async editperson(dataselected) {
			if (dataselected.status !== 0) {
				const selected = dataselected;
				selected.status = 0;
				await ecAxios
					.connection()
					.put(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO}${selected.id}`, selected)
					.then((response) => {
						if (response.status === 200) {
							this.getUsers();
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: e,
							type: 'is-danger',
						});
					});
			}
		},
		async getUsers() {
			this.isloading = true;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.ADM_USUARIOS}`, {
					offset: 0,
					limit: 1000,
				})
				.then((response) => {
					if (response) {
						this.dados = response.data.usuarios;
						this.datacarduser.qt = this.dados.length;
						this.isloading = false;
					}
				})
				.catch(() => {
					this.isloading = false;
				});
		},
	},
};
</script>

<style scoped>
.header-users {
	display: flex;
	width: 100%;
	justify-content: space-between;
	margin-bottom: 50px;
}
</style>

